import {
    apiRequest,
    salaryP3KDetail,
    salaryP3KUpdate,
    pangkatP3KList
} from "../../../../../services/adapters/master/salaryP3KService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", salaryP3KDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", salaryP3KUpdate, {
            body: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", pangkatP3KList, {
            params: query
        }, true)
    }
}

export default UpdateRepository